
const logo = (styleParams) => {
  const logo = document.getElementById('logo-printable')
  logo.style.marginLeft = styleParams.marginCenterContainer;
  logo.style.marginBottom = '16px';
  logo.style.height = '80px';
}

export { logo }
